import { createSlice } from '@reduxjs/toolkit';

import { ExamPattern } from './newTemplete';

type TestSession = {
  id: string;
  isActive: boolean;
  userId: string;
  createdDate: string; // or Date if you're parsing it
  updatedDate: string | null;
  isTestCompleted: boolean;
  testDTO: TestDTO;
  answers: null;
  additionalProps: null;
};

type TestDTO = {
  id: string;
  isActive: boolean;
  examPatternDTO: ExamPattern;
  questionIdList: [];
  createdDate: string;
  testName: string;
  updatedDate: null;
  additionalProps: null;
};

const initialState: TestSession[] = [
  {
    id: '',
    isActive: false,
    userId: '',
    createdDate: '',
    updatedDate: null,
    isTestCompleted: false,
    testDTO: {
      id: '',
      isActive: false,
      examPatternDTO: {
        id: '',
        isActive: false,
        companyId: '',
        yearOfPattern: 0,
        examName: '',
        totalRounds: 0,
        rounds: [],
        createdDate: '',
        updatedDate: null
      },
      questionIdList: [],
      createdDate: '',
      testName: '',
      updatedDate: null,
      additionalProps: null
    },
    answers: null,
    additionalProps: null
  }
];

const completedTestData = createSlice({
  name: 'completedTestData',
  initialState,
  reducers: {
    setCompleteTestData: (state, action) => {
      return action.payload;
    }
  }
});

export const { setCompleteTestData } = completedTestData.actions;
export default completedTestData.reducer;
